import type { DeliveryZoneDisplayType } from '~/api/DeliveryAddress';
import type { Order, OrderShort } from '~/api/Order';
import { useDeliveryZones } from '~/hooks/queries/useDeliveryZones';

const PUDO_DISPLAY_TYPES: DeliveryZoneDisplayType[] = ['pudo', 'zone'];

interface ZoneDescriptionProps {
  order: Order | OrderShort;
}

export const ZoneDescription = ({ order }: ZoneDescriptionProps) => {
  const { data: coverages } = useDeliveryZones(!!order.delivery_zone_id);

  if (!order.delivery_zone_id || !coverages) {
    return null;
  }

  const zone = coverages
    .flatMap((coverage) => coverage.zones)
    .find((z) => z?.id === order.delivery_zone_id);

  if (
    !zone ||
    !PUDO_DISPLAY_TYPES.includes(zone.displayType) ||
    !zone.description
  ) {
    return null;
  }

  return (
    <p
      className="order__details-item-content-value"
      style={{ whiteSpace: 'pre-line' }}
    >
      {zone.description}
    </p>
  );
};
